import { createPinia, setActivePinia } from 'pinia';
import { analyticsPlugin } from './plugins/analytics.plugin';
import { sessionPlugin } from './plugins/session.plugin';

export const pinia = createPinia();
// Required before vueApp.use(pinia): auth initialization runs before initVueApp(),
// and early initialization paths call useOrganizationStore()
// at action-invocation time. Without this, those calls throw "No active Pinia".
setActivePinia(pinia);

pinia.use(analyticsPlugin);
pinia.use(sessionPlugin);

export * from './themes.store';

export * from './layouts.store';

export { useDashboardsStore } from './dashboards.store';

export { useSavedViewsStore } from './saved-views.store';

export * from './smart-segments.store';

export { useSegmentsStore } from './segments.store';

export * from './domains.store';

export * from './essential-contacts.store';

export { usePagesStore } from './pages.store';

export * from './suggested-pages.store';

export * from './emails.store';
